












import { defineComponent, PropType } from '@vue/composition-api';
export interface BreadcrumbItem {
  link: string | null;
  text: string;
}

export default defineComponent({
  name: 'OareBreadcrumbs',
  props: {
    items: {
      type: Array as PropType<BreadcrumbItem[]>,
      required: true,
    },
  },
});
